import { render, staticRenderFns } from "./EditTopic.vue?vue&type=template&id=9b59069c&"
import script from "./EditTopic.vue?vue&type=script&lang=ts&"
export * from "./EditTopic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports